// extracted by mini-css-extract-plugin
export default {"modal":"Tutorial_modal__KrnKv","modalcontent":"Tutorial_modalcontent__W7asi","modalheader":"Tutorial_modalheader__EeyZK","close":"Tutorial_close__tEyKm"};